import { Grid, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FundraiserTitleAndValueRow } from './fundraiserTitleAndValueRow';
import { FundraiserPaymentDistributionResponse } from '../models/fundraiserPaymentDistributionResponse';

type FundraisingDistributionContentProps = {
  loading: boolean;
  paymentDistribution?: FundraiserPaymentDistributionResponse;
};

export const FundraisingDistributionContent = (props: FundraisingDistributionContentProps) => {
  const { loading, paymentDistribution } = props;
  const { t } = useTranslation();

  if (loading) {
    return (
      <>
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
        <Skeleton variant='text' sx={{ height: '40px', my: 1.5 }} />
      </>
    );
  }
  return (
    <>
      <Grid item xs={12}>
        <FundraiserTitleAndValueRow title={t('fundraiser:bankGiro')} currencyValue={paymentDistribution?.bankgiroAmount ?? 0} />
      </Grid>
      <Grid item xs={12}>
        <FundraiserTitleAndValueRow title={t('fundraiser:swish')} currencyValue={paymentDistribution?.swishAmount ?? 0} />
      </Grid>
      <Grid item xs={12}>
        <FundraiserTitleAndValueRow title={t('fundraiser:card')} currencyValue={paymentDistribution?.cardAmount ?? 0} />
      </Grid>
      <Grid item xs={12}>
        <FundraiserTitleAndValueRow title={t('fundraiser:checkout')} currencyValue={paymentDistribution?.cashAmount ?? 0} />
      </Grid>
    </>
  );
};
